import Product from '@/creditflowresearch/domain/Product/Product';
import CorporateProduct from '@/creditflowresearch/domain/Product/entities/CorporateProduct';
import type { IProductSelectionContext } from '@/creditflowresearch/domain/Product/selectors/selectDefaultAbsProduct';

export const selectDefaultCorporateProduct = (context: IProductSelectionContext): string => {
  const corporateProductId = CorporateProduct.CORPORATE_PRODUCT_IDS[0];
  const corporateProduct = Product.from(corporateProductId);

  if (!corporateProduct) {
    return corporateProductId;
  }

  const accessibleProducts = context.accessibleProductIds
    .map((id) => Product.from(id))
    .filter((product): product is Product => product !== null);

  const defaultProduct = CorporateProduct.getDefault({
    accessibleProducts,
    hasAccess: context.hasAccess,
  });

  if (!defaultProduct) {
    return corporateProductId;
  }

  const product = Product.from(defaultProduct.getId());
  return product?.getId() || defaultProduct.getId();
};
